import { getInverters } from 'common/api/productsSunwise';

import {
    FETCH_INVERTERS,
    FETCH_INVERTERS_FAILURE,
    FETCH_INVERTERS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default (filterData) => (dispatch) => {
    dispatch(actions[FETCH_INVERTERS]());

    const { brandName, financierProductId, page, pageSize, searchText } =
        filterData;

    getInverters({
        brandName,
        financierProductId,
        page: page + 1,
        pageSize,
        searchStr: searchText,
    })
        .then((response) => {
            dispatch(actions[FETCH_INVERTERS_SUCCESS](response.data));
        })
        .catch((error) =>
            dispatch(
                actions[FETCH_INVERTERS_FAILURE](error?.response?.data?.errors),
            ),
        );
};
